import React, { useState, useRef, useEffect } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

interface ImageUploadProps {
  currentImage?: string;
  onChange: (file: File | null) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ currentImage, onChange }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Mevcut resmi yükle
  useEffect(() => {
    if (currentImage) {
      console.log("Mevcut resim yükleniyor:", currentImage);
      setPreviewUrl(currentImage);
    } else {
      setPreviewUrl(null);
    }
  }, [currentImage]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setError(null);
    
    if (file) {
      // Dosya türü kontrolü
      if (!file.type.startsWith('image/')) {
        setError('Lütfen sadece resim dosyası yükleyin');
        onChange(null);
        return;
      }
      
      // Dosya boyutu kontrolü (5MB)
      if (file.size > 5 * 1024 * 1024) {
        setError('Resim dosyası 5MB\'dan küçük olmalıdır');
        onChange(null);
        return;
      }
      
      // Önizleme için URL oluştur
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
      
      onChange(file);
      console.log("Yeni resim seçildi:", file.name, file.type, file.size);
    } else {
      setPreviewUrl(null);
      onChange(null);
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleRemoveImage = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setPreviewUrl(null);
    onChange(null);
    console.log("Resim kaldırıldı");
  };

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex items-center space-x-4">
        <Button 
          type="button" 
          variant="outline" 
          onClick={handleButtonClick}
        >
          Resim Seç
        </Button>
        {previewUrl && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={handleRemoveImage}
          >
            Resmi Kaldır
          </Button>
        )}
        <Input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
      </div>
      
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
      
      {previewUrl && (
        <div className="relative w-full h-40 border rounded-md overflow-hidden">
          <img
            src={previewUrl}
            alt="Resim önizleme"
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
            onError={(e) => {
              console.error("Resim yükleme hatası:", e);
              setError("Resim yüklenirken bir hata oluştu");
              setPreviewUrl(null);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageUpload; 